/**
 * Recent commands storage for the Command Palette.
 *
 * Stored under `ghostcomm_recent_commands` so the panic button auto-wipes it.
 * Capped at 8 entries (we show the last 5).
 */

import { setItem as lsSet, removeItem as lsRemove } from './storage';

const LS_KEY = 'ghostcomm_recent_commands';
const MAX_STORED = 8;

/**
 * entry shape:
 *   { type: 'conv'|'dm'|'action', id: string, label: string, ts: number }
 */

export function loadRecentCommands() {
  try {
    const raw = window.localStorage.getItem(LS_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    if (!Array.isArray(arr)) return [];
    return arr.filter((e) => e && e.type && e.id && e.label);
  } catch {
    return [];
  }
}

export function recordRecentCommand(entry) {
  if (!entry || !entry.type || !entry.id || !entry.label) return;
  try {
    const existing = loadRecentCommands();
    // Dedupe by (type,id) — bump to top
    const deduped = existing.filter((e) => !(e.type === entry.type && e.id === entry.id));
    const next = [{ ...entry, ts: Date.now() }, ...deduped].slice(0, MAX_STORED);
    lsSet(LS_KEY, JSON.stringify(next));
  } catch {}
}

export function clearRecentCommands() {
  try {
    lsRemove(LS_KEY);
  } catch {}
}
